import { useState } from "react";
import { Box, Typography } from "@mui/material";
import UiSideModal from "components/base/UiSideModal";
import UiButton from "components/base/UiButton";
import { CostRow, Custom } from "./calculator";
import CustomMaterialQuantity, { materialQuantityPreview } from "./CustomMaterialQuantity";

export default function CustomMaterialCalculationDrawer({
  item,
  row,
  onApply,
  onClose,
  readOnly,
  busy,
  settings,
}: {
  item: Custom;
  row: CostRow;
  onApply: (row: CostRow) => void;
  onClose: () => void;
  readOnly: boolean;
  busy: boolean;
  settings: any;
}) {
  const [draft, setDraft] = useState(row);
  return (
    <UiSideModal open onClose={onClose} title="Calculate material quantity" width="598px">
      <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography sx={{ fontSize: 13 }}>
          Use the job size and coverage or weight settings to calculate how much material you need.
        </Typography>
        <CustomMaterialQuantity
          item={item}
          row={draft}
          onChange={(patch) => setDraft((current) => ({ ...current, ...patch }))}
          readOnly={readOnly}
          busy={busy}
          settings={settings}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <UiButton uiVariant="outlined-small" onClick={onClose}>
            {readOnly ? "Close" : "Cancel"}
          </UiButton>
          {!readOnly && (
            <UiButton
              uiVariant="primary-green"
              disabled={busy || !!materialQuantityPreview(item, draft).error}
              onClick={() => {
                onApply(draft);
                onClose();
              }}
            >
              Apply
            </UiButton>
          )}
        </Box>
      </Box>
    </UiSideModal>
  );
}
